import React, { useState, useEffect, useContext } from "react";

import DataTable from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import { ActionContext } from "context/ActionContext";
import {
  AutocompleteMultiselectCheckbox,
  MultiselectCheckbox,
  CustomSelect,
  IntInput,
} from "components/Input/Index.js";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import useActionTable from "./useActionTable.js";

//import "react-table/react-table.css";

// @mui/icons-material

import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

function RTProjectionsFluid (props) {
  const { setCalculate } = props;
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const { gridState } = useActionTable();
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const [newData, setNewData] = useState([]);
  const [editableRowId, setEditableRowId] = useState(false);

  const classes = useStyles();
  
  console.log(action);

  useEffect(() => {
    setNewData(gridState.data);
  }, [gridState.data]);

  //console.log(actionPlans.parameters.general.groups);

  // if (error) {
  //   return (
  //     <p>
  //       <span role="img" aria-label="Problem">
  //         🔧
  //       </span>{" "}
  //       Oups il semble y avoir un problème...{" "}
  //       <button onClick={refetch}>Réesayer</button>
  //     </p>
  //   );
  // }

  const columns = [
    {
      name: "Nom",
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
    },
    {
      name: "Production (MWh)",
      selector: (row) => row.projectedproduction,
      sortable: true,
      maxWidth: "10rem",
      omit: action?.parameters?.general?.category !== 'renewables',
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.id)].projectedproduction}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="projectedproduction"
          />
        ) : (
          row.projectedproduction ? new Intl.NumberFormat('fr-FR',{maximumFractionDigits : 2}).format( row.projectedproduction) : ''        
        ),
    },
    {
      name: "Economies (MWh ou m3)",
      selector: (row) => row.projectedfinalenergysavings,
      sortable: true,
      maxWidth: "10rem",
      omit: action?.parameters?.general?.category === 'contracts',
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.id)].projectedfinalenergysavings}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="projectedfinalenergysavings"
          />
        ) : (
          row.projectedfinalenergysavings ? new Intl.NumberFormat('fr-FR',{maximumFractionDigits : 2}).format( row.projectedfinalenergysavings) : ''
        ),
    },
    {
      name: "Economies (€)",
      selector: (row) => row.projectedsavings,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.id)].projectedsavings}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="projectedsavings"
          />
        ) : (
          row.projectedsavings ? new Intl.NumberFormat('fr-FR',{maximumFractionDigits : 2}).format( row.projectedsavings) : ''
        ),
    },
    {
      name: "Economies (kg eq CO2)",
      selector: (row) => row.projectedco2savings,
      sortable: true,
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.id)].projectedco2savings}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="projectedco2savings"
          />
        ) : (
          row.projectedco2savings ? new Intl.NumberFormat('fr-FR',{maximumFractionDigits : 2}).format( row.projectedco2savings) : ''
        ),
    },
    actionplanupdate && {
      name: "",
      sortable: false,
      width: "4rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Editer">
              <Button
                onClick={editEnabled(row)}
                color={editableRowId === row.id ? "info" : "success"}
                className={classes.actionButton}
              >
                {editableRowId === row.id ? (
                  <CheckIcon fontSize="large" />
                ) : (
                  <EditIcon fontSize="large" />
                )}
              </Button>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    const indexOfId = newData.findIndex((obj) => obj.id == id);

    let newArray = [...newData];
    newArray[indexOfId][name] = value;
    console.log(newArray);
    setNewData(newArray);
    setCalculate(true);
  };
  const editEnabled = (row) => async () => {
    console.log("edit is clicked", row.id);

    editableRowId === row.id
      ? setEditableRowId(null)
      : setEditableRowId(row.id);
  };
  function indexFinder(rowId) {
    console.log(rowId, newData);
    const indexOfId = newData.findIndex((obj) => obj.id == rowId);

    return indexOfId;
  }

  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noHeader={true}
        //title="Selection des parois"
        noDataComponent="Aucun fluide selectionné"
        columns={columns}
        subHeader
        persistTableHead
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
       // dense
        {...gridState}
      />
    </>
  );
};

export default RTProjectionsFluid;
